import remunerations from '../../mods/clinique/remunerations'

// Short-lived access, transfer and receipt tokens stay in the caller's request only.
export default {
    actions: {
        getTresoreriePaiementAccess() {
            return remunerations.getTresoreriePaiementAccess()
        },
        getTresorerieRemunerationAccess() {
            return remunerations.getTresorerieRemunerationAccess()
        },
        getRemunerationsEnAttente(context, access_token) {
            return remunerations.getRemunerationsEnAttente(access_token)
        },
        getRemunerationsEnAttenteV2(context, access_token) {
            return remunerations.getRemunerationsEnAttenteV2(access_token)
        },
        getPatientsRemunerations(context, data) {
            return remunerations.getPatientsRemunerations(data, data.access_token)
        },
        updateStatutRemunerations(context, data) {
            return remunerations.updateStatutRemunerations(data, data.access_token)
        },
        updateStatutRemunerationsV2(context, data) {
            return remunerations.updateStatutRemunerationsV2(data, data.access_token)
        },
        getCloturesEnAttente(context, access_token) {
            return remunerations.getCloturesEnAttente(access_token)
        },
        updateCloturesTransmises(context, data) {
            return remunerations.updateCloturesTransmises(data, data.access_token)
        }
    }
}
